import { render, staticRenderFns } from "./MagazineDetails.vue?vue&type=template&id=5f3e0b2a&"
import script from "./MagazineDetails.vue?vue&type=script&lang=js&"
export * from "./MagazineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports